import React from 'react';

import ChatView from './ChatView';
import { IEntityChatSalesRep } from './helpers';
import { IEntityChatMember } from './interface';

interface IEntityChatViewProps {
    entityId: string | number;
    entityType: 'order' | 'quote';
    connectedUsers?: IEntityChatMember[];
    mainLoading?: boolean;
    isActive?: boolean;
    hideHeader?: boolean;
    isFromWidget?: boolean;
    chatContainerClassName?: string;
    autoFocusInput?: boolean;
    entitySalesRep?: IEntityChatSalesRep | null;
}

const EntityChatView: React.FC<IEntityChatViewProps> = ({
    entityId,
    entityType,
    connectedUsers = [],
    mainLoading,
    isActive,
    hideHeader,
    isFromWidget,
    chatContainerClassName,
    autoFocusInput = true,
    entitySalesRep,
}) => (
    <ChatView
        entityId={entityId}
        entityType={entityType}
        connectedUsers={connectedUsers}
        mainLoading={mainLoading}
        isActive={isActive}
        hideHeader={hideHeader}
        isFromWidget={isFromWidget}
        chatContainerClassName={chatContainerClassName}
        autoFocusInput={autoFocusInput}
        entitySalesRep={entitySalesRep}
    />
);

export default EntityChatView;
